import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_API_URL || 'http://localhost:8080';

const authHeaders = (accessToken) => ({ Authorization: `Bearer ${accessToken}` });

export const SERVICE_PACKAGE_CATEGORIES = [
    { value: 'site', label: 'Création de site' },
    { value: 'referencement', label: 'Référencement' },
];

// ── Prestations ───────────────────────────────────────────────────────────

export async function getServicePackages(accessToken, category) {
    const res = await axios.get(`${API_URL}/api/service-packages`, {
        headers: authHeaders(accessToken),
        params: category ? { category } : {},
    });
    return res.data;
}

export async function getServicePackage(accessToken, id) {
    const res = await axios.get(`${API_URL}/api/service-packages/${id}`, { headers: authHeaders(accessToken) });
    return res.data;
}

export async function createServicePackage(accessToken, data) {
    const res = await axios.post(`${API_URL}/api/service-packages`, data, { headers: authHeaders(accessToken) });
    return res.data;
}

export async function updateServicePackage(accessToken, id, data) {
    const res = await axios.put(`${API_URL}/api/service-packages/${id}`, data, { headers: authHeaders(accessToken) });
    return res.data;
}

export async function deleteServicePackage(accessToken, id) {
    const res = await axios.delete(`${API_URL}/api/service-packages/${id}`, { headers: authHeaders(accessToken) });
    return res.data;
}

// ── Options d'une prestation ─────────────────────────────────────────────

export async function createServicePackageOption(accessToken, servicePackageId, data) {
    const res = await axios.post(`${API_URL}/api/service-packages/${servicePackageId}/options`, data, { headers: authHeaders(accessToken) });
    return res.data;
}

export async function updateServicePackageOption(accessToken, servicePackageId, optionId, data) {
    const res = await axios.put(`${API_URL}/api/service-packages/${servicePackageId}/options/${optionId}`, data, { headers: authHeaders(accessToken) });
    return res.data;
}

export async function deleteServicePackageOption(accessToken, servicePackageId, optionId) {
    const res = await axios.delete(`${API_URL}/api/service-packages/${servicePackageId}/options/${optionId}`, { headers: authHeaders(accessToken) });
    return res.data;
}

// ── Plaquette PDF ─────────────────────────────────────────────────────────

export async function uploadServicePackageBrochure(accessToken, servicePackageId, file) {
    const form = new FormData();
    form.append('brochure', file);
    const res = await axios.post(`${API_URL}/api/service-packages/${servicePackageId}/brochure`, form, {
        headers: { ...authHeaders(accessToken), 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
}

export async function deleteServicePackageBrochure(accessToken, servicePackageId) {
    const res = await axios.delete(`${API_URL}/api/service-packages/${servicePackageId}/brochure`, { headers: authHeaders(accessToken) });
    return res.data;
}
